module.exports = __webpack_public_path__ + "static/media/Scheduler_NewAppointment.fdaaf7e5.svg";